// extracted by mini-css-extract-plugin
export default {"blogCard":"blogsCardStyles_blogCard__lKYdX","blogImg":"blogsCardStyles_blogImg__kYorI","readMoreDiv":"blogsCardStyles_readMoreDiv__pMvBL"};